import styled from '@emotion/styled';
import { SPACING } from '@zola/zola-ui/src/styles/emotion';

export const StyledDiv = styled.div`
  margin-top: ${SPACING.LG};
`;
